import { AxiosRequestConfig, AxiosError } from 'axios';
import { BaseQueryFn } from '@reduxjs/toolkit/query';
import { BaseQueryError } from './types';
import { api } from '../services/api';

export const baseQuery =
  (
    { baseUrl }: { baseUrl: string } = { baseUrl: process.env.REACT_APP_API_URL || '' }
  ): BaseQueryFn<AxiosRequestConfig, unknown, BaseQueryError> =>
  async ({ url, method = 'GET', ...requestConfig }) => {
    try {
      const result = await api({
        url,
        baseURL: baseUrl,
        method,
        ...requestConfig,
      });
      return { data: result.data };
    } catch (axiosError) {
      console.error(axiosError);
      const err = axiosError as AxiosError;
      return {
        error: {
          status: err.response?.status || 500,
          data: err.response?.data,
          message: err.response?.data.message || 'Could not connect to server. Please try again later.',
        },
      };
    }
  };
